export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15011.6a3e03f0.jpg";